import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qzyztvqjv: FaireProductEntity = {
  token: "p_4qzyztvqjv",
  type: "product",
  name: "Spring Bee Porcelain Dinner Plate – 8 in. Round",
  brandToken: "b_m8c3mbnsfa",
  brandName: "Urban Tokyo",
  imageUrl: "https://cdn.faire.com/fastly/f4d34b295b907d418332419b3735635f09178a0e3c35c30e2f102e1d8070cfc5.png",
  galleryImageUrls: [],
  priceDollars: 5.5,
  description: "Bring a refined, restaurant-ready look to the table with this 8\" dinner plate. A versatile plate for entrées, rice dishes, salads and shared plates. Decorated with a Spring Bee design. Made from restaurant-grade porcelain, it is built for busy restaurants, sushi bars, ramen shops, cafés and catering, while looking just as good on the family dinner table. A thoughtful gift for home cooks, it brings the look of Japanese ceramic pottery to any kitchen.\n\nFeatures\n\n * Restaurant-grade porcelain: made for the demands of daily commercial service \n * Easy care: microwave and dishwasher safe \n * Coordinated collection: mix with the other 8 in. designs: Hummingbird, Koi Fish, Maple Leaf, Cherry Blossoms and Panda Plum Blossoms \nSpecifications\n\n * Size: 8\" Dia x 1\" H \n * Material: Porcelain (restaurant grade) \n * Design: Spring Bee \n * Inner pack: 4 \n * Case pack: 32 \n * Origin: China \n * Care: Microwave and dishwasher safe. ",
  tags: [],
  msrpDollars: 12.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:02:38.181Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
